import { Typography, Box, Button } from '@mui/material';
import { Plus } from '@phosphor-icons/react';
import { useUser } from '../../hooks/useUser';
import { useNavigate } from 'react-router';
import { routes } from '../../constants/routes';

const AgentAndBusinessButton = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  const isJourneyComplete =
    user?.journey?.businessDetails &&
    user?.journey?.brandDetails &&
    user?.journey?.storeDetails;

  return (
    <Box>
      <Button
        variant="contained"
        startIcon={
          isJourneyComplete ? (
            <Plus weight="bold" size={16} color="#FFFFFF" />
          ) : null
        }
        sx={{
          textTransform: 'none',
          width: '100%',
          textAlign: 'center',
          borderRadius: '6px',
          backgroundColor: 'primary.main',
          color: 'white',
          fontSize: '14px',
          fontWeight: '600',
          justifyContent: 'center',
          paddingX: '16px',
          boxShadow: 'none',
        }}
        onClick={() =>
          isJourneyComplete
            ? navigate(routes.agentCreation)
            : navigate(routes.setUpBusiness)
        }
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {isJourneyComplete ? ' Create Agent' : 'Setup Business'}
        </Typography>
      </Button>
    </Box>
  );
};

export default AgentAndBusinessButton;
